import styled from 'styled-components';

interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  label: string;
}

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #fff;
  min-width: 80px;
`;

const CheckboxInput = styled.input`
  accent-color: #fff;
  width: 16px;
  height: 16px;
`;

const Checkbox = ({ checked, onChange, label }: CheckboxProps) => (
  <CheckboxLabel>
    <CheckboxInput type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </CheckboxLabel>
);

interface FilterPanelProps {
  filters: {
    nameChecked: boolean;
    name: string;
    countChecked: boolean;
    count: string;
    equipmentChecked: boolean;
    equipment: string;
  };
  onChange: (name: string, value: boolean | string) => void;
  onSearch: () => void;
}

const FilterPanel = ({ filters, onChange, onSearch }: FilterPanelProps) => {
  return (
    <Panel>
      <Row>
        <Checkbox
          checked={filters.nameChecked}
          onChange={() => onChange('nameChecked', !filters.nameChecked)}
          label="대원명"
        />
        <Input
          type="text"
          placeholder="전체"
          value={filters.name}
          onChange={(e) => onChange('name', e.target.value)}
          disabled={!filters.nameChecked}
        />
        <Button onClick={onSearch}>검색</Button>
      </Row>
      <Row>
        <Checkbox
          checked={filters.countChecked}
          onChange={() => onChange('countChecked', !filters.countChecked)}
          label="동원수"
        />
        <Input
          type="text"
          inputMode="numeric"
          value={filters.count}
          disabled={!filters.countChecked}
          onChange={(e) => onChange('count', e.target.value)}
          onFocus={(e) => {
            if (e.target.value === '0') onChange('count', '');
          }}
          onBlur={(e) => {
            if (e.target.value === '') onChange('count', '0');
          }}
        />
        <span style={{ color: '#fff', fontSize: 16, fontWeight: 500 }}>이상</span>
        <Button onClick={onSearch}>검색</Button>
      </Row>
      <Row>
        <Checkbox
          checked={filters.equipmentChecked}
          onChange={() => onChange('equipmentChecked', !filters.equipmentChecked)}
          label="보유장비"
        />
        <Input
          type="text"
          placeholder="전체"
          value={filters.equipment}
          onChange={(e) => onChange('equipment', e.target.value)}
          disabled={!filters.equipmentChecked}
        />
        <Button onClick={onSearch}>필터</Button>
      </Row>
    </Panel>
  );
};

const Panel = styled.div`
  background: #06163a;
  padding: 1rem 0.5rem;
  border-radius: 12px;
  width: 100%;
  height: 9rem;
  color: #fff;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
`;
const Input = styled.input`
  flex: 1;
  background: #0a2647;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  width: 70px;
  height: 28px;
  text-align: center;
  margin: 0 4px;
  &::placeholder {
    color: #fff;
    opacity: 1;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
  }

  /* Chrome, Safari, Edge, Opera */
  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Button = styled.button`
  width: 50px;
  height: 28px;
  background: #0a2647;
  color: #fff;
  border: 1px solid #ffffff;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
  &:hover {
    background: #144272;
  }
`;

export default FilterPanel;
